/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrderpickerTarget } from '../../models/orderpicker-target';

export interface GetOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Params {
  orderpickerId: number;
  id: number;

/**
 * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
 */
  fields?: Array<string>;

/**
 * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
 */
  join?: Array<string>;

/**
 * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
 */
  cache?: number;
}

export function getOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget(http: HttpClient, rootUrl: string, params: GetOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderpickerTarget>> {
  const rb = new RequestBuilder(rootUrl, getOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget.PATH, 'get');
  if (params) {
    rb.path('orderpickerId', params.orderpickerId, {});
    rb.path('id', params.id, {});
    rb.query('fields', params.fields, {});
    rb.query('join', params.join, {});
    rb.query('cache', params.cache, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrderpickerTarget>;
    })
  );
}

getOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget.PATH = '/api/mgmt/orderpicker/{orderpickerId}/targets/{id}';
